import {useQuery} from 'react-query';
import RateServiceApi from 'api/rate-service-api';
import {useMemo} from 'react';
import {homeSafeStandardTiersQueryKey} from 'constants/query';
import {statusToLoading} from 'adapter/loading.adapter';
import {uniqBy} from 'lodash';

export function useHomeSafeStandardMetricsQuery(props = {}) {
  const {enabled = true, ProductId, State} = props;
  const {
    data: metrics = [],
    status,
    isFetching,
  } = useQuery({
    queryKey: [homeSafeStandardTiersQueryKey, ProductId, State],
    async queryFn() {
      const response = await RateServiceApi.getHomeSafeStandardTiers({'State': State, 'ProductId': ProductId});

      response.data = uniqBy(response.data, 'HomeSafeMetricId');

      return response;
    },
    enabled,
  });

  const data = useMemo(() => metrics.filter((metric) => metric.ProductId === ProductId), [metrics, ProductId]);
  const defaultTier = useMemo(() => data.find((tier) => tier?.IsDefault), [data]);
  const loading = useMemo(() => statusToLoading(status, isFetching), [status, isFetching]);

  return {data, defaultTier, status, loading};
}
